/**
 * 批量注册组件
 * @param { Vue } Vue
 * @param { Object } components components hash
 */
export function registerComponents (Vue, components) {
  return Object.keys(components).forEach(v => Vue.component(v, components[v]))
}
